module.exports = __webpack_public_path__ + "static/media/ic-delete.3090ad3c.svg";